import type { Me } from '../types/auth'
import { isPlatformAdmin } from './roles'

// Temporary second copy of the rules in docs/ui-uplift/roles.md, for the navigation only.
// It goes once /api/v1/me?org_id= returns the permission keys (roles.md, "How the frontend
// uses this"). Platform-admin-only screens stay on the platformAdminOnly flag.
export type ShellRole = 'consultant' | 'sponsor' | 'employee'
export const SHELL_ROLES: ShellRole[] = ['consultant', 'sponsor', 'employee']

const CLIENT: ShellRole[] = ['consultant', 'sponsor', 'employee']
const SPONSOR: ShellRole[] = ['consultant', 'sponsor']
const TEAM: ShellRole[] = ['consultant']

export const PERMISSIONS = {
  'clara.chat': CLIENT,
  'org.overview': TEAM,
  'process.view_approved': CLIENT,
  'process.manage': TEAM,
  'process.upload_documents': SPONSOR,
  'process.landscape': CLIENT,
  'interview.view_sources': TEAM,
  'interview.configure': TEAM,
  'interview.own': ['sponsor', 'employee'],
  'tobe.view': SPONSOR,
  'initiative.view': SPONSOR,
  'agent.view': SPONSOR,
  'usage.view': TEAM,
  'knowledge.view': CLIENT,
  'knowledge.configure': TEAM,
  'profile.view': CLIENT,
  'ai_tools.use': CLIENT,
  'settings.manage': TEAM,
} as const satisfies Record<string, readonly ShellRole[]>

export type Permission = keyof typeof PERMISSIONS

export function can(role: ShellRole, permission: Permission): boolean {
  return (PERMISSIONS[permission] as readonly ShellRole[]).includes(role)
}

// Platform admins and operators without a membership yet use the consultant shell.
export function shellRoleOf(me: Me | null | undefined): ShellRole {
  if (isPlatformAdmin(me)) return 'consultant'
  const role = me?.user?.role
  return role === 'sponsor' || role === 'employee' ? role : 'consultant'
}
